import React, { useState, useEffect } from 'react';
import { Field, reduxForm } from 'redux-form';
import { Grid, Container, MenuItem, Button, Typography, Radio, RadioGroup, FormControlLabel, Paper, Table, TableHead, TableBody, TableRow, TableCell, TablePagination, IconButton, Tooltip, CircularProgress, InputAdornment, TextField as MuiTextField, TableContainer, Box, Chip } from '@material-ui/core';
import VisibilityIcon from '@material-ui/icons/Visibility';
import DescriptionIcon from '@material-ui/icons/Description';
import SearchIcon from '@material-ui/icons/Search';
import FileUpload from './FileUpload';
import { connect } from 'react-redux';
import SelectField from './SelectField';
import SelectSearch from './SelectSearch';
import Checkbox from './Checkbox';
import KeyboardDatePicker from './KeyboardDatePicker';
// import FieldTextField from './FieldTextField';
import TextField from '../components/TextField';
import { currency, parseFechaEmisionUTC } from '../services/utils';
import { getCurrentUser } from '../services/auth';
import { API_RENDICIONES } from '../utils/urls';
import moment from 'moment';
import 'moment/locale/es';
moment.locale('es');

const API_GESTOR_PAGOS = process.env.REACT_APP_API_GESTOR_PAGOS || 'https://test-api-gestor-pagos.cydocs.cl';

const validate = (values = {}) => {
    const errors = {};
    const requiredFields = [
        'tipo_doc',
        'numero',
        'monto',
        'fecha_doc',
        'fecha',
        'file',
        'calidad1',
        'calidad2',
        'calidad3',
        'calidad4',
        'calidad5',
        'calidad6',
        'calidad7',
        'estado_pago',
        'clasificacion_factura',
        'iva',
        'descripcion'
    ];
    // if (values['tipo_doc'] == 'Factura') requiredFields.push('estado_pago');
    requiredFields.forEach(field => {
        if (!values[field]) {
            errors[field] = true;
        }
    });
    if (values.monto == "0") errors['monto'] = true;
    if (values['dias_vencimiento'] != 0 && values['dias_vencimiento'] != 15 && values['dias_vencimiento'] != 30 && values['dias_vencimiento'] != 45) errors['dias_vencimiento'] = true;
    // if (values.email && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)) {
    //     errors.email = 'Invalid email address';
    // }
    return errors;
};

const RadioGroupField = ({ input, meta: { touched, error }, children, ...custom }) => (
    <RadioGroup
        row
        value={input.value}
        onChange={input.onChange}
        style={{ color: touched && error ? '#ff0000' : '#000000de', margin: '5px 0' }}>
        <FormControlLabel style={{ marginBottom: 0 }} value="1" control={<Radio color="primary" />} label="Sí" />
        <FormControlLabel style={{ marginBottom: 0 }} value="0" control={<Radio color="primary" />} label="No" />
        <FormControlLabel style={{ marginBottom: 0 }} value="2" control={<Radio color="primary" />} label="N/A" />
    </RadioGroup>
);

let FormItemRecibido = props => {
    const {
        handleSubmit,
        handleOnChangeFileComprobante,
        fileName,
        formRecibir,
        tipoRecepcion,
        change,
        touch,
        todoRecibido,
        dataCotizacion,
        handleClose,
        // Props para facturas Facele
        facturasFacele,
        loadingFacturasFacele,
        searchFacturaFacele,
        handleSearchFacturaFacele,
        handleBuscarFacturaFacele,
        selectedFacturaFacele,
        handleSelectFacturaFacele,
        currentPageFacturas,
        pageSizeFacturas,
        totalCountFacturas,
        handleChangePageFacturas,
        handleChangeRowsPerPageFacturas,
        facturaFaceleSeleccionada,
        handleLimpiarFacturaFacele
    } = props;
    const [clasificacionFactura, setClasificacionFactura] = useState([]);
    // console.log("estado RUT", estadoRUT);

    useEffect(() => {
        let fetchData = async () => {
            let token = await getCurrentUser();
            let clasif = await fetch(`${API_RENDICIONES}/clasificaciones-facturas`, {
                method: 'GET',
                headers: {
                    Authorization: 'Bearer ' + token.token
                },
                // body: JSON.stringify(values)
            });
            let dataClasif = await clasif.json();
            setClasificacionFactura([...dataClasif.data]);
        }
        fetchData();
    }, []);

    // Cargar facturas automáticamente cuando se selecciona Factura y Documento Aprobado
    useEffect(() => {
        if (formRecibir?.values?.tipo_doc === 'Factura' &&
            formRecibir?.values?.estado_pago === 'Documento Aprobado' &&
            handleBuscarFacturaFacele) {
            handleBuscarFacturaFacele();
        }
    }, [formRecibir?.values?.tipo_doc, formRecibir?.values?.estado_pago, handleBuscarFacturaFacele]);

    // Limpiar campos cuando se cambia el estado de pago desde Documento Aprobado
    useEffect(() => {
        // Si no es Factura + Documento Aprobado, limpiar los campos que se llenaron desde Facele
        if (formRecibir?.values?.tipo_doc !== 'Factura' ||
            formRecibir?.values?.estado_pago !== 'Documento Aprobado') {
            if (facturaFaceleSeleccionada && change && handleLimpiarFacturaFacele) {
                // Limpiar los campos que se llenaron automáticamente
                change('numero', '');
                change('monto', '0');
                change('iva', '0');
                change('fecha_doc', null);
                // Limpiar el estado de factura seleccionada
                handleLimpiarFacturaFacele();
            }
        }
    }, [formRecibir?.values?.tipo_doc, formRecibir?.values?.estado_pago]);

    // Limpiar archivo cuando se cambia el tipo de documento o estado de pago
    useEffect(() => {
        if (fileName && change && handleOnChangeFileComprobante) {
            // Limpiar el archivo seleccionado
            handleOnChangeFileComprobante({ target: { files: [] } });
            change('file', null);
        }
    }, [formRecibir?.values?.tipo_doc, formRecibir?.values?.estado_pago]);

    let opcionesEstadoPago =
        ['Anticipo', 'Pago Online'].indexOf(dataCotizacion.condicion_pago) > -1
            ? [
                  { nombre: 'Pago Inmediato Realizado', valor: 'Pago inmediato' },
                  { nombre: 'Orden de pago directo a proveedor', valor: 'Documento Aprobado' },
                  { nombre: 'Pagado', valor: 'Pagado' }
              ]
            : [
                  { nombre: 'Orden de pago directo a proveedor', valor: 'Documento Aprobado' },
                  { nombre: 'Pagado', valor: 'Pagado' }
              ];

    return (
        <Container>
            <form noValidate onSubmit={handleSubmit}>
                {/* {tipoRecepcion != 'todos' && (
                    <Grid container spacing={3}>
                        <Grid item xs={12} lg={6}>
                            <Grid container justify="center" alignItems="center">
                                <Field
                                    style={{ width: '90%' }}
                                    label="Items Recepcionados"
                                    name="entregados"
                                    component={TextField}
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    InputProps={{
                                        disabled: true
                                    }}
                                />
                            </Grid>
                        </Grid>
                        <Grid item xs={12} lg={6}>
                            <Grid container justify="center" alignItems="center">
                                <Field
                                    style={{ width: '90%' }}
                                    type="number"
                                    name="cantidad"
                                    label="Items a Recepcionar"
                                    component={TextField}
                                    //normalize={numero}
                                    // validate={[maxValue]}
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                />
                            </Grid>
                        </Grid>
                    </Grid>
                )} */}
                <Grid container spacing={3}>
                    <Grid item xs={12} lg={6}>
                        <Grid container justify="center" alignItems="center">
                            <Field
                                required
                                style={{ width: '95%' }}
                                name="tipo_doc"
                                label="Tipo"
                                component={SelectField}>
                                {[
                                    <MenuItem key="" value="">
                                        Seleccionar
                                    </MenuItem>
                                ].concat(
                                    ['Guía Despacho', 'Factura'].map((x, id) => (
                                        <MenuItem key={id} value={x}>
                                            {x}
                                        </MenuItem>
                                    ))
                                )}
                            </Field>
                        </Grid>
                    </Grid>
                    {formRecibir?.values?.tipo_doc === 'Factura' && (
                        <Grid item xs={12} lg={6}>
                            <Grid container justify="center" alignItems="center">
                                <Field
                                    required
                                    style={{ width: '95%' }}
                                    disabled={['Anticipo', 'Pago Online'].indexOf(dataCotizacion.condicion_pago) > -1}
                                    name="estado_pago"
                                    label="Estado del pago"
                                    component={SelectField}>
                                    {[
                                        <MenuItem key="" value="">
                                            Seleccionar
                                        </MenuItem>
                                    ].concat(
                                        opcionesEstadoPago.map((x, id) => (
                                            <MenuItem key={id} value={x.valor}>
                                                {x.nombre}
                                            </MenuItem>
                                        ))
                                    )}
                                </Field>
                            </Grid>
                        </Grid>
                    )}
                </Grid>
                {formRecibir?.values?.tipo_doc === 'Factura' && formRecibir?.values?.estado_pago == 'Documento Aprobado' && (
                    <>
                        {/* Título */}
                        <Grid container spacing={3} style={{ marginTop: 20, marginBottom: 10 }} alignItems="center">
                            <Grid item xs={12}>
                                <Typography variant="h6">Facturas Disponibles</Typography>
                            </Grid>
                        </Grid>
                        {/* Contenedor con texto y buscador */}
                        <Box
                            style={{
                                borderRadius: '8px',
                                border: '1px solid #e0e0e0',
                                overflow: 'hidden'
                            }}>
                            <Grid container style={{ marginBottom: 0 }}>
                                <Grid item xs={12} >
                                    <Box
                                        style={{
                                            padding: '12px 16px',
                                            backgroundColor: '#fff',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'space-between',
                                            minHeight: '56px'
                                        }}>
                                    <Typography variant="body2" style={{ fontSize: '14px', color: '#666', fontWeight: 400 }}>
                                        Seleccione una fila para autocompletar
                                    </Typography>
                                    <MuiTextField
                                        style={{ width: 300 }}
                                        placeholder="Buscar facturas..."
                                        variant="outlined"
                                        size="small"
                                        value={searchFacturaFacele || ''}
                                        onChange={(e) => handleSearchFacturaFacele(e.target.value)}
                                        InputProps={{
                                            startAdornment: (
                                                <InputAdornment position="start">
                                                    <SearchIcon color="action" />
                                                </InputAdornment>
                                            ),
                                        }}
                                    />
                                </Box>
                                </Grid>
                            </Grid>
                            {loadingFacturasFacele ? (
                            <Grid container justify="center" alignItems="center" style={{ padding: 40 }}>
                                <Grid item>
                                    <CircularProgress size={40} />
                                </Grid>
                                <Grid item xs={12} style={{ textAlign: 'center', marginTop: 16 }}>
                                    <Typography variant="body1">Cargando facturas...</Typography>
                                </Grid>
                            </Grid>
                        ) : facturasFacele && facturasFacele.length > 0 ? (
                            <Grid container spacing={0} style={{ marginBottom: 0 }}>
                                <Grid item xs={12}>
                                    <TableContainer component={Paper} style={{ flex: 1, position: 'relative' }}>
                                        <Table stickyHeader size="small">
                                            <TableHead>
                                                <TableRow>
                                                    <TableCell
                                                        padding="checkbox"
                                                        style={{
                                                            backgroundColor: '#fff',
                                                            position: 'sticky',
                                                            left: 0,
                                                            zIndex: 3
                                                        }}>
                                                    </TableCell>
                                                    <TableCell
                                                        style={{
                                                            backgroundColor: '#fff',
                                                            minWidth: 100
                                                        }}>
                                                        <strong>Folio</strong>
                                                    </TableCell>
                                                    <TableCell
                                                        style={{
                                                            backgroundColor: '#fff',
                                                            minWidth: 300
                                                        }}>
                                                        <strong>Sociedad</strong>
                                                    </TableCell>
                                                    <TableCell
                                                        style={{
                                                            backgroundColor: '#fff',
                                                            minWidth: 120
                                                        }}>
                                                        <strong>Fecha Factura</strong>
                                                    </TableCell>
                                                    <TableCell
                                                        align="right"
                                                        style={{
                                                            backgroundColor: '#fff',
                                                            minWidth: 120
                                                        }}>
                                                        <strong>Monto Total</strong>
                                                    </TableCell>
                                                    <TableCell
                                                        align="right"
                                                        style={{
                                                            backgroundColor: '#fff',
                                                            minWidth: 120
                                                        }}>
                                                        <strong>IVA</strong>
                                                    </TableCell>
                                                    <TableCell
                                                        align="center"
                                                        style={{
                                                            backgroundColor: '#fff',
                                                            minWidth: 150
                                                        }}>
                                                        <strong>Notas de Crédito</strong>
                                                    </TableCell>
                                                    <TableCell
                                                        align="center"
                                                        style={{
                                                            backgroundColor: '#fff',
                                                            minWidth: 120
                                                        }}>
                                                        <strong>Orden de compra</strong>
                                                    </TableCell>
                                                    <TableCell
                                                        align="center"
                                                        style={{
                                                            backgroundColor: '#fff',
                                                            position: 'sticky',
                                                            right: 0,
                                                            zIndex: 3,
                                                            minWidth: 100
                                                        }}>
                                                        <strong>Acciones</strong>
                                                    </TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {facturasFacele.map((factura) => (
                                                    <TableRow
                                                        key={factura._id}
                                                        hover
                                                        style={{ cursor: 'pointer' }}
                                                        selected={selectedFacturaFacele?._id === factura._id}
                                                        onClick={() => handleSelectFacturaFacele(factura)}>
                                                        <TableCell
                                                            padding="checkbox"
                                                            style={{
                                                                position: 'sticky',
                                                                left: 0,
                                                                backgroundColor: selectedFacturaFacele?._id === factura._id ? '#e3f2fd' : '#fff',
                                                                zIndex: 2
                                                            }}>
                                                            <Radio
                                                                checked={selectedFacturaFacele?._id === factura._id}
                                                                color="primary"
                                                            />
                                                        </TableCell>
                                                        <TableCell><strong>{factura.folio_dte}</strong></TableCell>
                                                        <TableCell>{factura.razon_social_receptor || '—'}</TableCell>
                                                        <TableCell>{parseFechaEmisionUTC(factura.fecha_emision)?.format('DD/MM/YYYY') || '—'}</TableCell>
                                                        <TableCell align="right">${factura.monto_total?.toLocaleString('es-CL')}</TableCell>
                                                        <TableCell align="right">${factura.monto_iva?.toLocaleString('es-CL')}</TableCell>
                                                        <TableCell align="center">
                                                            {factura.notas && factura.notas.length > 0 ? (
                                                                <Box style={{ display: 'flex', gap: '4px', justifyContent: 'center', flexWrap: 'wrap' }}>
                                                                    {factura.notas.map((nota, index) => (
                                                                        <Tooltip key={index} title={`Ver Nota de Crédito N° ${nota.folio}`}>
                                                                            <Chip
                                                                                size="small"
                                                                                icon={<DescriptionIcon style={{ fontSize: 16 }} />}
                                                                                label={`N° ${nota.folio}`}
                                                                                onClick={(e) => {
                                                                                    e.stopPropagation();
                                                                                    if (nota.url_pdf) {
                                                                                        window.open(nota.url_pdf, '_blank');
                                                                                    }
                                                                                }}
                                                                                style={{
                                                                                    cursor: 'pointer',
                                                                                    backgroundColor: '#e8f5e9',
                                                                                    color: '#2e7d32'
                                                                                }}
                                                                            />
                                                                        </Tooltip>
                                                                    ))}
                                                                </Box>
                                                            ) : (
                                                                <Typography variant="body2" style={{ color: '#999', fontSize: '12px' }}>
                                                                    —
                                                                </Typography>
                                                            )}
                                                        </TableCell>
                                                        <TableCell align="center">
                                                            {factura.codigo_oc ? (
                                                                <Typography variant="body2" style={{ fontSize: '14px' }}>
                                                                {factura.codigo_oc}
                                                            </Typography>
                                                            ): (
                                                                <Typography variant="body2" style={{ color: '#999', fontSize: '12px' }}>
                                                                    —
                                                                </Typography>
                                                            )}

                                                        </TableCell>
                                                        <TableCell
                                                            align="center"
                                                            style={{
                                                                position: 'sticky',
                                                                right: 0,
                                                                backgroundColor: selectedFacturaFacele?._id === factura._id ? '#e3f2fd' : '#fff',
                                                                zIndex: 2
                                                            }}>
                                                            <Tooltip title="Ver Factura PDF">
                                                                <IconButton
                                                                    size="small"
                                                                    style={{ color: "#4A4B4D" }}
                                                                    onClick={(e) => {
                                                                        e.stopPropagation();
                                                                        if (factura.url_pdf) {
                                                                            window.open(factura.url_pdf, '_blank');
                                                                        }
                                                                    }}>
                                                                    <VisibilityIcon fontSize="small" />
                                                                </IconButton>
                                                            </Tooltip>
                                                        </TableCell>
                                                    </TableRow>
                                                ))}
                                            </TableBody>
                                        </Table>
                                        <TablePagination
                                            component="div"
                                            count={totalCountFacturas || 0}
                                            page={currentPageFacturas || 0}
                                            onChangePage={handleChangePageFacturas}
                                            rowsPerPage={pageSizeFacturas || 5}
                                            onChangeRowsPerPage={handleChangeRowsPerPageFacturas}
                                            rowsPerPageOptions={[5, 10, 20, 50]}
                                            labelRowsPerPage="Filas por página:"
                                            labelDisplayedRows={({ from, to, count }) => `${from}-${to} de ${count}`}
                                        />
                                    </TableContainer>
                                </Grid>
                            </Grid>
                        ) : (
                            <Grid container justify="center" style={{ padding: 20 }}>
                                <Typography variant="body2" color="textSecondary">
                                    No se encontraron facturas disponibles para este proveedor.
                                </Typography>
                            </Grid>
                        )}
                        </Box>
                    </>
                )}
                {formRecibir?.values?.tipo_doc && (
                    <Grid container spacing={3} style={{marginTop: 16}}>
                        <Grid item xs={12} lg={6}>
                            <Grid container justify="center" alignItems="center">
                                <Field
                                    required
                                    style={{ width: '95%' }}
                                    name="fecha_doc"
                                    label="Fecha Documento *"
                                    change={change}
                                    component={KeyboardDatePicker}
                                    disabled={formRecibir?.values?.tipo_doc === 'Factura' && formRecibir?.values?.estado_pago === 'Documento Aprobado'}
                                    InputProps={{
                                        style: (formRecibir?.values?.tipo_doc === 'Factura' && formRecibir?.values?.estado_pago === 'Documento Aprobado') ? { backgroundColor: '#f5f5f5', color: '#757575' } : {}
                                    }}
                                />
                            </Grid>
                        </Grid>
                        <Grid item xs={12} lg={6}>
                            <Grid container justify="center" alignItems="center">
                                <Field
                                    required
                                    style={{ width: '95%' }}
                                    name="fecha"
                                    label="Fecha Recepción *"
                                    change={change}
                                    // format="DD/MM/YYYY"
                                    component={KeyboardDatePicker}
                                />
                            </Grid>
                        </Grid>
                    </Grid>
                )}
                {formRecibir?.values?.tipo_doc === 'Factura' && formRecibir?.values?.estado_pago == 'Documento Aprobado' && (
                    <Grid container spacing={3}>
                        <Grid item xs={12} lg={6}>
                            <Grid container justify="center" alignItems="center">
                                <Field
                                    required
                                    style={{ width: '95%' }}
                                    name="clasificacion_factura"
                                    label="Clasificación Factura"
                                    type="text"
                                    change={change}
                                    touch={touch}
                                    options={clasificacionFactura}
                                    component={SelectSearch}
                                />
                            </Grid>
                        </Grid>
                        <Grid item xs={12} lg={6}>
                            <Grid container justify="center" alignItems="center">
                                <Field
                                    required
                                    style={{ width: '95%' }}
                                    name="dias_vencimiento"
                                    label="Plazo Pago"
                                    component={SelectField}>
                                    {[
                                        <MenuItem key="" value="">
                                            Seleccionar
                                        </MenuItem>
                                    ].concat(
                                        [
                                            { nombre: 'Contado', valor: 0 },
                                            { nombre: 'A 15 días', valor: 15 },
                                            { nombre: 'A 30 días', valor: 30 },
                                            { nombre: 'A 45 días', valor: 45 }
                                        ].map((x, id) => (
                                            <MenuItem key={id} value={x.valor}>
                                                {x.nombre}
                                            </MenuItem>
                                        ))
                                    )}
                                </Field>
                            </Grid>
                        </Grid>
                    </Grid>
                )}
                {formRecibir?.values?.tipo_doc && (
                    <Grid container spacing={3}>
                        <Grid item xs={12} lg={6}>
                            <Grid container justify="center" alignItems="center">
                                <Field
                                    required
                                    style={{ width: '95%' }}
                                    type="number"
                                    name="numero"
                                    label="Número Documento"
                                    component={TextField}
                                    disabled={formRecibir?.values?.tipo_doc === 'Factura' && formRecibir?.values?.estado_pago === 'Documento Aprobado'}
                                    InputProps={{
                                        style: (formRecibir?.values?.tipo_doc === 'Factura' && formRecibir?.values?.estado_pago === 'Documento Aprobado') ? { backgroundColor: '#f5f5f5', color: '#757575' } : {}
                                    }}
                                />
                            </Grid>
                        </Grid>
                        {formRecibir?.values?.tipo_doc === 'Factura' && (
                            <Grid item xs={12} lg={3}>
                                <Grid container justify="center" alignItems="center">
                                    <Field
                                        required
                                        style={{ width: '90%' }}
                                        format={currency}
                                        // type="text"
                                        name="monto"
                                        label="Total Factura"
                                        component={TextField}
                                        disabled={formRecibir?.values?.tipo_doc === 'Factura' && formRecibir?.values?.estado_pago === 'Documento Aprobado'}
                                        InputProps={{
                                            startAdornment: <InputAdornment position="start">$</InputAdornment>,
                                            style: (formRecibir?.values?.tipo_doc === 'Factura' && formRecibir?.values?.estado_pago === 'Documento Aprobado') ? { backgroundColor: '#f5f5f5', color: '#757575' } : {}
                                        }}
                                    />
                                </Grid>
                            </Grid>
                        )}
                        {formRecibir?.values?.tipo_doc === 'Factura' && (
                            <Grid item xs={12} lg={3}>
                                <Grid container justify="center" alignItems="center">
                                    <Field
                                        required
                                        style={{ width: '90%' }}
                                        format={currency}
                                        // type="text"
                                        name="iva"
                                        label="IVA Factura"
                                        component={TextField}
                                        disabled={formRecibir?.values?.tipo_doc === 'Factura' && formRecibir?.values?.estado_pago === 'Documento Aprobado'}
                                        InputProps={{
                                            startAdornment: <InputAdornment position="start">$</InputAdornment>,
                                            style: (formRecibir?.values?.tipo_doc === 'Factura' && formRecibir?.values?.estado_pago === 'Documento Aprobado') ? { backgroundColor: '#f5f5f5', color: '#757575' } : {}
                                        }}
                                    />
                                </Grid>
                            </Grid>
                        )}
                    </Grid>
                )}
                {formRecibir?.values?.tipo_doc === 'Factura' && formRecibir?.values?.estado_pago == 'Documento Aprobado' && (
                    <Grid container spacing={3}>
                        <Grid item xs={12} lg={6}>
                            <Grid container justify="center" alignItems="center">
                                <Field
                                    required
                                    multiline
                                    type="text"
                                    name="descripcion"
                                    rows="4"
                                    characterLimit={200}
                                    inputProps={{
                                        maxLength: '200'
                                    }}
                                    style={{ width: '95%' }}
                                    label="Descripción"
                                    component={TextField}
                                />
                            </Grid>
                        </Grid>
                        <Grid item xs={12} lg={6}>
                            <Grid container justify="center" alignItems="center">
                                <Field
                                    multiline
                                    type="text"
                                    name="comentario"
                                    rows="4"
                                    characterLimit={200}
                                    inputProps={{
                                        maxLength: '200'
                                    }}
                                    style={{ width: '95%' }}
                                    label="Comentario (opcional)"
                                    component={TextField}
                                />
                            </Grid>
                        </Grid>
                    </Grid>
                )}
                {formRecibir?.values?.tipo_doc &&
                 !(formRecibir?.values?.tipo_doc === 'Factura' && formRecibir?.values?.estado_pago === 'Documento Aprobado') && (
                    <FileUpload
                        fileName={fileName}
                        onChange={(e) => {
                            handleOnChangeFileComprobante(e);
                            if (e.target.files && e.target.files[0]) {
                                change('file', e.target.files[0]);
                            }
                        }}
                        onClear={() => {
                            handleOnChangeFileComprobante({ target: { files: [] } });
                            change('file', null);
                        }}
                        label="Archivo comprobante"
                        inputId="file-upload-recepcion"
                    />
                )}
                {todoRecibido && (
                    <div style={{ marginTop: 30 }}>
                        <Grid container spacing={1}>
                            <Grid item xs={12}>
                                <Typography variant="h6" gutterBottom>
                                    Evaluación de Calidad <span style={{ color: '#d32f2f' }}>*</span>
                                </Typography>
                            </Grid>
                        </Grid>
                        <Grid container style={{ marginTop: 16 }}>
                            {/* Columna izquierda */}
                            <Grid item xs={12} lg={6} style={{ paddingRight: 12 }}>
                                <div style={{ display: 'flex', flexDirection: 'column', gap: 32 }}>
                                    {/* Pregunta 1 */}
                                    <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
                                        <Field name="calidad1" component={RadioGroupField} />
                                        <Typography variant="body2" style={{ fontSize: 14, lineHeight: '20px' }}>
                                            ¿Los recursos fueron entregados junto a guía o factura?
                                        </Typography>
                                    </div>
                                    {/* Pregunta 2 */}
                                    <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
                                        <Field name="calidad2" component={RadioGroupField} />
                                        <Typography variant="body2" style={{ fontSize: 14, lineHeight: '20px' }}>
                                            ¿Proveedor entrega bultos correctamente embalados y rotulados?
                                        </Typography>
                                    </div>
                                    {/* Pregunta 3 */}
                                    <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
                                        <Field name="calidad3" component={RadioGroupField} />
                                        <Typography variant="body2" style={{ fontSize: 14, lineHeight: '20px' }}>
                                            ¿La cantidad recibida corresponde a la indicada en guía o factura?
                                        </Typography>
                                    </div>
                                    {/* Pregunta 4 */}
                                    <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
                                        <Field name="calidad4" component={RadioGroupField} />
                                        <Typography variant="body2" style={{ fontSize: 14, lineHeight: '20px' }}>
                                            ¿Los recursos fueron entregados sin defectos o daños?
                                        </Typography>
                                    </div>
                                </div>
                            </Grid>
                            {/* Columna derecha */}
                            <Grid item xs={12} lg={6} style={{ paddingLeft: 12, borderLeft: '1px solid #f3f3f4' }}>
                                <div style={{ display: 'flex', flexDirection: 'column', gap: 32 }}>
                                    {/* Pregunta 5 */}
                                    <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
                                        <Field name="calidad5" component={RadioGroupField} />
                                        <Typography variant="body2" style={{ fontSize: 14, lineHeight: '20px' }}>
                                            ¿La cantidad entregada cumple con la cantidad solicitada en OC?
                                        </Typography>
                                    </div>
                                    {/* Pregunta 6 */}
                                    <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
                                        <Field name="calidad6" component={RadioGroupField} />
                                        <Typography variant="body2" style={{ fontSize: 14, lineHeight: '20px' }}>
                                            ¿Los recursos corresponden a lo solicitado?
                                        </Typography>
                                    </div>
                                    {/* Pregunta 7 */}
                                    <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
                                        <Field name="calidad7" component={RadioGroupField} />
                                        <Typography variant="body2" style={{ fontSize: 14, lineHeight: '20px' }}>
                                            ¿El precio o monto facturado, corresponde a lo indicado en cotización/orden de compra?
                                        </Typography>
                                    </div>
                                </div>
                            </Grid>
                        </Grid>
                    </div>
                )}
                <Grid container spacing={3}>
                    <Grid item xs={12}>
                        <Grid
                            container
                            style={{
                                borderTop: '1px solid #dcddde',
                                paddingTop: '24px',
                                paddingBottom: '24px',
                                marginTop: '20px',
                                paddingLeft: '24px',
                                paddingRight: '24px',
                                marginLeft: '-24px',
                                marginRight: '-24px',
                                width: 'calc(100% + 48px)'
                            }}
                            justify="flex-end"
                            alignItems="center"
                            spacing={2}>
                            <Grid item>
                                <Button
                                    variant="outlined"
                                    color="default"
                                    style={{ width: '190px', height: '40px' }}
                                    onClick={handleClose}>
                                    Cancelar
                                </Button>
                            </Grid>
                            <Grid item>
                                <Button
                                    type="submit"
                                    variant="contained"
                                    color="primary"
                                    disabled={props.invalid || props.submitting}
                                    style={{ width: '190px', height: '40px', marginLeft: '8px' }}>
                                    Recepcionar
                                </Button>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </form>
        </Container>
    );
};

FormItemRecibido = reduxForm({
    form: 'recibirItems'
})(FormItemRecibido);

export default connect((state, props) => ({
    initialValues: {
        file: '',
        fecha: null,
        fecha_doc: null,
        // fecha_vencimiento: moment().format('DD/MM/YYYY'),
        numero: '',
        monto: '0',
        iva: '0',
        descripcion: props.descripcion,
        comentario: '',
        estado_pago:
            ['Anticipo', 'Pago Online'].indexOf(props?.dataCotizacion?.condicion_pago) > -1
                ? 'Pago inmediato'
                : null
        // cantidad: 1,
        // max: props.max,
        // entregados: props.entregados
    },
    enableReinitialize: true,
    validate
}))(FormItemRecibido);
